module.exports = __webpack_public_path__ + "static/img/img.fa53bd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-field-call/img.png
// module id = HkUS
// module chunks = 7